import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

import type {BankState} from '../types';

export const useBankStore = create<BankState>()(
  devtools(
    (set) => ({
      // State
      accountTypesOptions: [],

      // Actions
      setAccountTypeOptions: (options) =>
        set({accountTypesOptions: options}, false, 'bank/setAccountTypeOptions')
    }),
    {name: 'BankStore'}
  )
);

// Selectors
export const selectAccountTypesOptions = (state: BankState) =>
  state.accountTypesOptions;
